<template>
  <form class="side_box" :style="style" @submit.prevent="stopEditing">
    <div v-if="!isEditing" class="user-picture">
      <img :src="this.details.userPicture" />
    </div>
    <div v-if="isEditing" class="user-picture">
      <ImageInput v-model="avatar">
        <div slot="activator">
          <div v-if="!avatar" class="image-selector">
            <img :src="this.details.userPicture" alt="avatar" />
          </div>
          <div v-else class="image-selector selected">
            <img :src="avatar.imageURL" alt="avatar" />
          </div>
        </div>
      </ImageInput>
    </div>
    <div v-if="!isEditing">
      <label for="Comments">First Name</label>
      <span v-if="this.details.firstName">{{this.details.firstName}}</span>
      <span v-else>/</span>
    </div>
    <InputDash
      v-else
      label="Firstname"
      name="firstname"
      :isTextArea="false"
      placeholder="Firstname"
      :isDisabled="false"
      v-model="firstname"
      :validation="!this.inValidFields.includes('firstname')"
      class="btm-margin"
    />

    <div v-if="!isEditing">
      <label for="lastname">Last Name</label>
      <span v-if="this.details.lastName">{{this.details.lastName}}</span>
      <span v-else>/</span>
    </div>
    <InputDash
      v-else
      label="Lastname"
      name="lastname"
      :isTextArea="false"
      placeholder="Lastname"
      :isDisabled="false"
      v-model="lastname"
      :validation="!this.inValidFields.includes('lastname')"
      class="btm-margin"
    />

    <div v-if="!isEditing">
      <label for="permissions">Permissions</label>
      <span v-if="this.details.isAdmin == 1">Administrator</span>
      <span v-else>Operator</span>
    </div>
    <div v-if="isEditing">
      <label for="permissions">Permissions</label>
      <InputRadio
        class="radio-buttons"
        label
        :isDetail="true"
        name="permissions"
        :isAdmin="this.details.isAdmin ? true : false"
        v-model="permissionsText"
      />
    </div>

    <div v-if="!isEditing">
      <label for="password">Password</label>
      <span>••••••••••</span>
    </div>
    <div v-if="isEditing">
      <label for="password">Password</label>
      <InputSecure
        name="password"
        :isTextArea="false"
        placeholder="Password"
        :isDisabled="false"
        :isHidden="false"
        v-model="password"
        :totalChar="10"
        :isNumberOnly="false"
        :validation="!this.inValidFields.includes('password')"
      />
    </div>

    <div v-if="!isEditing">
      <label for="pincode">Pincode</label>
      <span>•••••</span>
    </div>
    <div v-if="isEditing">
      <label for="pincode">Pincode</label>
      <InputSecure
        name="pincode"
        :isTextArea="false"
        placeholder="Pincode"
        :isDisabled="false"
        :isHidden="false"
        v-model="pincode"
        :totalChar="5"
        :isNumberOnly="true"
        :validation="!this.inValidFields.includes('pincode')"
      />
    </div>

    <div v-if="!isEditing">
      <label for="email">Email</label>
      <span v-if="this.details.email">{{this.details.email}}</span>
      <span v-else>/</span>
    </div>
    <InputDash
      v-else
      label="Email"
      name="email"
      :isTextArea="false"
      placeholder="Email"
      :isDisabled="false"
      v-model="email"
      :validation="!this.inValidFields.includes('mail')"
      class="btm-margin"
    />

    <BaseButton v-if="isEditing && this.details.userID != this.userDetails.userID" type="button" size="fullWidth-Low" color="error" @click.native="deleteUser()">
      <span class="span-btndelete">Delete User</span>
    </BaseButton>

    <div v-if="!isEditing && this.userDetails.isAdmin == 1" class="icon submit" @click="startEditing">
      <BaseIcon name="pen" class="icon" />
    </div>
    <button v-if="isEditing" class="no-btn icon submit" type="submit">
      <BaseIcon name="save" class="icon" />
    </button>
  </form>
</template>

<script>
import BaseIcon from "@/components/base/Icon";
import BaseButton from "@/components/base/Button";
import InputDash from "@/components/base/InputDash.vue";
import InputRadio from "@/components/base/InputRadio.vue";
import ImageInput from "@/components/base/ImageInput.vue";
import InputSecure from "@/components/base/InputSecure.vue";

export default {
  components: {
    BaseIcon,
    BaseButton,
    ImageInput,
    InputRadio,
    InputDash,
    InputSecure
  },
  computed: {
    style() {
      return "height: " + this.height + "%";
    },
    userDetails() {
      return this.$store.state.userDetails
    }
  },
  props: {
    height: String,
    details: Object
  },
  data() {
    return {
      isEditing: false,
      userID: String,
      userPicture: String,
      firstname: String,
      lastname: String,
      permissionsText: String,
      isAdmin: Number,
      password: String,
      pincode: Number,
      email: String,
      avatar: null,
      saving: false,
      saved: false,
      passwordEdit: false,
      pincodeEdit: false,
      dataEdit: false,
      imageEdit: false,
      inValidFields: []
    };
  },
  watch: {
    avatar: {
      handler: function() {
        this.saved = false;
      },
      deep: true
    },
    details: {
      handler: function() {
        this.isEditing = false;
        this.setSelectedData();
      }
    }
  },
  mounted() {
    this.setSelectedData();
  },
  methods: {
    setSelectedData() {
      this.userID = this.details.userID;
      this.firstname = this.details.firstName;
      this.lastname = this.details.lastName;
      this.userPicture = this.details.userPicture;
      this.isAdmin = this.details.isAdmin;
      this.permissionsText = this.details.isAdmin ? "admin" : "operator";
      this.password = "************";
      this.pincode = "*****";
      this.email = this.details.email;
    },
    startEditing() {
      this.isEditing = true;
    },
    deleteUser() {  
      var that = this
      this.$http.delete(this.$endpoint + 'management/users/' + this.details.userID)
      .then(response => {
        that.isEditing = false;
        that.$emit("refresh", true);
        that.$swal(
          "User deleted!",
          `Your user has been successfully removed. This means that this user will not be able to use the platform, all data submitted by this user will still be available.`,
          "success"
        );
      })
      .catch(error => {
        if (error.response.status === 401) {
          this.$store
          .dispatch("logout")
          .then(() => this.$router.push("/login"))
          .catch(err => console.log(err));
        } else {
          that.$swal(
            'Oops that went wrong?',
            `Please contact the admin with the following info: ${ error }`,
            'error'
          );
        }
      })
    },
    putUser: function() {
      var that = this;
      this.inValidFields = [];

      if(this.firstname == "" || /^[a-zA-z0-9-_]*$/.test(this.firstname) == false) {
        this.inValidFields.push("firstname")
      }
      
      if(this.lastname == "" || /^[a-zA-z0-9-_]*$/.test(this.lastname) == false) {
        this.inValidFields.push("lastname")
      }

      if (this.email == "") {
        this.inValidFields.push("mail");
      }

      if (this.password == "" || this.password.length < 8) {
        this.inValidFields.push("password");
      }

      if (this.pincode == "" || this.pincode.length != 5) {
        this.inValidFields.push("pincode");
      }

      var picture, hasPicture;
      if (this.avatar != null) {
        picture = this.avatar.base64;
        hasPicture = true;
      } else {
        picture = "";
        hasPicture = false;
      }

      if (this.password != "************") {
        this.passwordEdit = true
      }

      if (this.pincode != "*****") {
        this.pincodeEdit = true
      }

      if (this.inValidFields.length == 0) {
        this.$http
          .put(this.$endpoint + "management/users/edit", {
            userID: this.userID,
            email: this.email,
            firstName: this.firstname,
            lastName: this.lastname,
            isAdmin: this.permissionsText == "admin" ? 1 : 0,
            password: this.password,
            pincode: this.pincode,
            passwordEdit: this.passwordEdit,
            pincodeEdit: this.pincodeEdit,
            dataEdit: true,
            userPicture: picture,
            hasImage: hasPicture
          })
          .then(function(response) {
            that.isEditing = false;
            that.$emit("refresh", true);
            that.$swal(
              "User updated!",
              `Your user has been successfully updated.`,
              "success"
            );
          })
          .catch(function(error) {
            that.$swal(
              "Oops that went wrong?",
              `Please contact the admin with the following info: ${error}`,
              "error"
            );
          });
      }
    },
    stopEditing() {
      this.putUser();
    },
    uploadImage() {
      this.saving = true;
      setTimeout(() => this.savedAvatar(), 1000);
    },
    savedAvatar() {
      this.saving = false;
      this.saved = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/sideBox";
@import "@/style/components/inputs";
@import "@/style/components/buttons";

.side_box {
  max-height: 690px;

  .span-btndelete {
    height: auto;
    margin-bottom: 0;
  }

  label {
    height: 20px;
  }

  input,
  span {
    height: 30px;
    margin-bottom: 15px;
  }

  .user-picture {
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      margin: 24px 0;
      border-radius: 6px;
      height: 120px;
      width: 120px;
    }

    .image-selector,
    .image-selector > img {
      &:hover {
        cursor: pointer;
      }

      &.selected > img {
        border: 1px solid #dddddd;
        object-fit: cover;
      }
    }
  }
}
</style>
